import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { FeedbackItem } from '../models/feedback.types';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  public errorMessage = signal<string | null>(null);
  public feedbackList = signal<FeedbackItem[]>([]);

  loadFeedback(startDate: Date, endDate: Date) {
    const params = new HttpParams()
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    this.http.get<FeedbackItem[]>(`${this.apiUrl}/backoffice/feedback`, { params }).subscribe({
      next: (data) => this.feedbackList.set(data),
      error: (err) => this.errorMessage.set(err.message),
    });
  }
}
